import { XYZ } from 'ol/source';
import { mapStore } from 'stores/Map';
import { SystemStore } from "stores/System";

export const useMapImages = () => {
    const { baseImageLayer, baseImageSource, compareImageLayer, compareImageSource, targetWMTSLayer, baseWMTSLayer } = mapStore();
    const { isKamcoDemo } = SystemStore();

    const drawBaseImage = (url: string) => {
        baseImageSource && baseImageSource.setUrl(url);
    };

    const drawCompareImage = (url: string) => {
        compareImageSource && compareImageSource.setUrl(url);
    };

    //타일 이미지 Opacity
    const updateBaseImageOpacity = (opacity: number) => {
        baseImageLayer?.setOpacity(opacity);
        compareImageLayer?.hasListener('prerender') && compareImageLayer.setOpacity(opacity);

        if (isKamcoDemo) {
            baseWMTSLayer?.setOpacity(opacity);
            targetWMTSLayer?.setOpacity(opacity);
        }
    };

    //타일 이미지 Visible
    const updateBaseImageVisible = (is: boolean) => {
        baseImageLayer?.setVisible(is);
        compareImageLayer?.hasListener('prerender') && compareImageLayer.setVisible(is);
    };

    const clearBaseImage = () => {
        if (!(baseImageSource instanceof XYZ)) return;
        baseImageSource.clear();
        baseImageSource.setUrl('');
        updateBaseImageOpacity(100);
        updateBaseImageVisible(true);
    };

    const clearCompareImage = () => {
        if (!(compareImageSource instanceof XYZ)) return;
        compareImageSource.clear();
        compareImageSource.setUrl('');
        compareImageLayer?.setOpacity(100);
        compareImageLayer?.setVisible(true);
    };

    return {
        drawBaseImage,
        drawCompareImage,
        updateBaseImageOpacity,
        updateBaseImageVisible,
        clearBaseImage,
        clearCompareImage
    };
};
